import reviewService from "../../services/reviewService";
import * as types from "./types";
import { initialState } from "./initialState";

const service = new reviewService();
export const getReviewDataList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.FETCH_DATA,
      payload: { loader: true },
    });
    service
      .getReviewDataList(data)
      .then((res) => {
        dispatch({
          type: types.FETCH_DATA,
          payload: { data: res.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.FETCH_DATA,
          payload: {
            ...initialState,
            msg: "error",
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const getReviewMenu = (data) => {
  return (dispatch) => {
    service
      .getReviewMenu(data)
      .then((res) => {
        dispatch({
          type: types.FETCH_MENU,
          payload: { data: res.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.FETCH_MENU,
          payload: {
            ...initialState,
            message: "error",
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const getBatchMetaData = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.FETCH_METADATA,
      payload: { ...initialState, loader: true },
    });
    service
      .getBatchMetaData(data)
      .then((res) => {
        dispatch({
          type: types.FETCH_METADATA,
          payload: { data: res.data.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.FETCH_METADATA,
          payload: {
            // ...initialState,
            msg: "error",
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const uploadMedia = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.UPLOAD_MEDIA,
      payload: { ...initialState, loader: true },
    });
    service
      .uploadMediaFiles(data)
      .then((res) => {
        dispatch({
          type: types.UPLOAD_MEDIA,
          payload: {
            data: res.data,
            message: res.data.message,
            status: 200,
            loader: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.UPLOAD_MEDIA,
          payload: {
            ...initialState,
            errors: error?.response?.data?.errors,
            message: error?.response?.data?.message || "Error",
            file_name: error?.response?.data?.file_name || "",
            summary:error?.response?.data?.error_summary,
            loader: false,
            next: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};

export const getReviewAudit = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.AUDIT_REVIEW_DATA,
      payload: { ...initialState, loader: true },
    });
    service
      .getReviewAudit(data)
      .then((res) => {
        dispatch({
          type: types.AUDIT_REVIEW_DATA,
          payload: { data: res.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.AUDIT_REVIEW_DATA,
          payload: {
            ...initialState,
            msg: "error",
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const updateBatchData = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_DATA,
      payload: { ...initialState, loader: true },
    });
    service
      .updateBatchData(data)
      .then((res) => {
        dispatch({
          type: types.UPDATE_DATA,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loader: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.UPDATE_DATA,
          payload: {
            ...initialState,
            data: "",
            message: error?.response?.data?.message || "Error",
            loader: false,
            next: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};

export const approveBatch = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.UPLOAD_MEDIA,
      payload: { ...initialState, loader: true },
    });
    service
      .approveBatch(data)
      .then((res) => {
        dispatch({
          type: types.UPLOAD_MEDIA,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loader: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.UPLOAD_MEDIA,
          payload: {
            ...initialState,
            message: error?.response?.data?.message || "Error",
            loader: false,
            next: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};

export const downloadTemplate = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.DOWNLOAD_TEMPLATE,
      payload: { ...initialState, loader: true },
    });
    service
      .downloadTemplate(data)
      .then((res) => {
        dispatch({
          type: types.DOWNLOAD_TEMPLATE,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loader: false,
          },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.DOWNLOAD_TEMPLATE,
          payload: {
            ...initialState,
            message: error?.response?.data?.message || "Error",
            loader: false,
            next: false,
            status: error.response?.status || 500,
          },
        });
      });
  };
};


export const getSummaryList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.SUMMARY_DATA,
      payload: { ...initialState, loader: true },
    });
    service
      .getSummaryList(data)
      .then((res) => {
        dispatch({
          type: types.SUMMARY_DATA,
          payload: { data: res.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.SUMMARY_DATA,
          payload: {
            ...initialState,
            msg: "error",
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const getUserList = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.USER_LIST,
      payload: { ...initialState, loader: true },
    });
    service
      .getUserList(data)
      .then((res) => {
        dispatch({
          type: types.USER_LIST,
          payload: { data: res.data, loader: false },
        });
      })
      .catch((error) => {
        dispatch({
          type: types.USER_LIST,
          payload: {
            ...initialState,
            msg: "error",
            loader: false,
            next: false,
          },
        });
      });
  };
};

export const ApproveMultiBatch = ( payload) => {
  return (dispatch) => {
    dispatch({
      type: types.APPROVE_MULTI_BATCH,
      payload: { ...initialState, loading: true },
    });
   return service
      .approveMultiBatch( payload)
      .then((res) => {
        dispatch({
          type: types.APPROVE_MULTI_BATCH,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res
      })
      .catch((error) => {
        dispatch({
          type: types.APPROVE_MULTI_BATCH,
          payload: {
            ...initialState,
            message: error.response.error || "Error fetching data",
            loading: false,
            status: error.response?.status || 500,
          },
        });
        throw error;
      });
  };
};


export const getCopiedBatches = (params) => {
  return () => service.getCopiedBatches(params);
};
export const getHistoricalBatchMetadata = (params) => {
  return () => service.getReviewMenu(params);
};
export const getCopyBatchPreview = (params) => {
  return () => service.getCopyBatchPreview(params);
};

export const copyBatch = (payload) => {
  return () => service.copyBatch(payload);
};

export const addBatchRow = (payload) => {
  return () => service.addBatchRow(payload);
};

export const downloadExcelTemplate = (data) => {
  return (dispatch) => {
    dispatch({
      type: types.DOWNLOAD_EXCEL_TEMPLATE,
      payload: { ...initialState, loading: true },
    });
    return service
      .downloadExcelTemplate(data)
      .then((res) => {
        dispatch({
          type: types.DOWNLOAD_EXCEL_TEMPLATE,
          payload: {
            data: res.data.data,
            message: res.data.message,
            status: 200,
            loading: false,
          },
        });
        return res
      })
      .catch((error) => {
        dispatch({
          type: types.DOWNLOAD_TEMPLATE,
          payload: {
            ...initialState,
            message: error?.response?.data?.error || "Error",
            loading: false,
            next: false,
            status: error.response?.status || 500,
          },
        });
        throw error
      });
  };
};
